import { Typography } from "@mui/material";
import { TextInput, ValidateForm } from "react-admin";
import { FieldValues } from "react-hook-form";

import { storage } from "../../storage";
import { DataKind, Region } from "../../types";
import validators from "../../utils/Validators";
import { CustomCreate } from "../custom";

interface ManualWorkerFormData {
  work_item_name: string;
  payload: string;
}

function ManualWorkerCreate(props: { region: Region }) {
  const adminUserEmail = storage.loadAuthInfo()?.admin_user.email;

  const validateForm: ValidateForm = (values: FieldValues) => {
    return validators.validateJsonPayload(values.payload);
  };

  const transform = (data: ManualWorkerFormData) => ({
    ...data,
    admin_user_email: adminUserEmail,
  });

  return (
    <CustomCreate
      checkPermissionFor={DataKind.ManualWorker}
      validate={validateForm}
      transform={transform}
    >
      <TextInput
        label="Work Item Name"
        source="work_item_name"
        placeholder="i.e ExampleManualWorkItem"
        disabled={adminUserEmail == null}
        required
      />
      <TextInput
        label="JSON Payload"
        source="payload"
        disabled={adminUserEmail == null}
      />
      {adminUserEmail == null && (
        <Typography
          component="p"
          sx={{ color: "fieldwire.gray.1", fontSize: "14px" }}
        >
          ⚠️ Current admin user email not found. Please log out and log in
          again.
        </Typography>
      )}
    </CustomCreate>
  );
}

export default ManualWorkerCreate;
